import { CRAWL_START_DATE } from "@config/beyondWords";
import { ENABLE_TTS } from "@helper/getEnvVariables";

export function shouldShowTTSPlayer(datetime: string): boolean {
  const startDate = new Date(CRAWL_START_DATE).getTime();
  const publishedTime =
    typeof datetime === "string" ? new Date(datetime).getTime() : 0;

  return parseInt(ENABLE_TTS) === 1 && publishedTime >= startDate;
}
